// hooks/useUIHelpers.js

import { useEffect } from "react";

export const useUIHelpers = () => {
  useEffect(() => {
    const preventRightClick = (e) => {
      //e.preventDefault();
    };

    const handleKeyDown = (e) => {
      if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I")) {
        //e.preventDefault();
      }
    };

    const handleClickOutside = (event) => {
      const element = document.getElementById("kt_quick_panel");
      const bodyElement = document.querySelector("body");

      if (
        element &&
        element.classList.contains("offcanvas-on") &&
        !element.contains(event.target)
      ) {
        element.classList.remove("offcanvas-on");
        if (bodyElement && bodyElement.classList.contains("overflow-hidden")) {
          bodyElement.classList.remove("overflow-hidden");
        }
      }
    };

    document.addEventListener("contextmenu", preventRightClick);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("contextmenu", preventRightClick);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
};
